function QuotationMarkSvg() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="39" height="30" fill="none"><path fill="#868993" d="M7.775 16.02c3.878.102 7.143 2.858 7.143 6.94 0 3.877-3.06 7.04-7.143 7.04-4.387 0-7.04-3.265-7.04-7.96 0-8.673 8.571-18.367 17.55-22.04L19 1.122C13.796 4.184 7.877 9.694 7.775 16.02Zm20 0c3.878.102 7.143 2.858 7.143 6.94 0 3.877-3.06 7.04-7.143 7.04-4.387 0-7.04-3.265-7.04-7.96 0-8.673 8.571-18.367 17.55-22.04L39 1.122C33.796 4.184 27.878 9.694 27.775 16.02Z" /></svg>
  )
}

export default QuotationMarkSvg
